<template>
  <div class="page-billing">
    <PageHeader>
      <div class="heading">
        <h1>Billing Central</h1>
      </div>
    </PageHeader>

    <div class="page-columns" v-if="currentUser.owns_company || currentUser.admin ">
      <div class="col main">
        <div class="billing-links">
          <router-link
            class="billing-link"
            :to="{name: 'plans', params: {companyId: companyId}}">
            <Sprite name="invoice"/>
            <span>Plans</span>
          </router-link>

          <router-link
            class="billing-link"
            :to="{name: 'payment-methods', params: {companyId: companyId}}">
            <Sprite name="credit-cards"/>
            <span>Payment Methods</span>
          </router-link>

          <router-link
            class="billing-link"
            :to="{name: 'invoices', params: {companyId: companyId}}">
            <Sprite name="history"/>
            <span>Billing History</span>
          </router-link>
        </div>
      </div>

      <div class="col side">
        <PageSummary>
          <div>
            <h1>Your Billing Area</h1>
            <p>
              Welcome to your billing area. Here, you can view your
              <strong>plans</strong>, <strong>payment methods</strong>, and access your
              <strong>billing history</strong>.
            </p>
            <p>For security, we ensure that only the company owner can view and manage any billing information. Your team members don't have access to this.</p>
          </div>
        </PageSummary>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'

import page from '@/mixins/page'

import PageHeader from '@/components/PageHeader'
import PageSummary from '@/components/PageSummary'
import Sprite from '@/components/Sprite'

export default {
  name: 'billing',

  mixins: [page],

  props: {
    companyId: String
  },

  data() {
    return {
      title: 'Billing Central'
    }
  },

  components: {
    PageHeader,
    PageSummary,
    Sprite
  },

  computed: {
    ...mapState(['currentUser']),

    protocol() {
      return window.location.protocol + '//'
    },

    successUrl() {
      return `${this.protocol + window.location.host}/companies/${
        this.companyId
      }/payment/complete`
    },

    cancelUrl() {
      return `${this.protocol + window.location.host}/companies/${
        this.companyId
      }/payment/cancelled`
    }
  }
}
</script>

<style lang="sass" scoped>
@import '../../stylesheets/base/variables'
@import '../../stylesheets/helpers/mixins'
@import '../../stylesheets/helpers/extends'

.page-billing
  @extend %page

.billing-links
  width: 100%
  display: flex
  flex-direction: column
  flex-wrap: wrap
  align-items: flex-start
  justify-content: center
  text-transform: uppercase

  @include media($media-gt-medium)
    flex-direction: row

  .billing-link
    @extend %card
    width: calc(100% - #{$gap-small*2})
    margin: $gap-small
    padding: $gap-x-large $gap-medium
    display: flex
    align-items: center
    flex-direction: column
    font-size: 12px
    text-align: center

    @include media($media-gt-medium)
      width: auto
      flex-basis: calc(#{percentage(1/3)} - #{$gap-small*3})

    @include themify($themes)
      color: themed('color-secondary')

    &:hover
      .sprite
        transform: scale(1.1)

        @include themify($themes)
          fill: themed('color-primary')

  .sprite
    fill: rgba(0, 0, 0, 0.1)
    width: 40px
    height: 40px
    margin-bottom: $gap-medium
    transition: all .2s ease-in-out
</style>
